import { AllFTUXes, isNull } from '@aloft/toolkit-shared';

import { useEffect } from 'react';

import { PageID } from '../../../components/ReferenceBar/HelpDrawer/types.ts';
import { useFTUX } from '../../../controller/hooks/useFTUX.ts';
import {
  setReferenceViewOpen,
  setSelectedDataSheet,
} from '../../../redux/features/referenceBarUISlice.ts';
import { selectReferenceBarUI } from '../../../redux/features/selectors/referenceBarUISelectors.ts';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.ts';

export function useAutoOpenHelpDrawer({ pageID }: { pageID: PageID | null }) {
  const dispatch = useAppDispatch();
  const { alertsPanelAutoOpenedForNavBlock } = useAppSelector(selectReferenceBarUI);
  const { ftux, dismiss } = useFTUX(`autoHelpDrawer-${pageID}` as keyof AllFTUXes);

  useEffect(() => {
    if (alertsPanelAutoOpenedForNavBlock || isNull(pageID) || !ftux()) return;
    dispatch(setSelectedDataSheet('help-drawer'));
    dispatch(setReferenceViewOpen(true));
    dismiss(); // set count to greater than max, so we don't keep re-opening
  }, [alertsPanelAutoOpenedForNavBlock, pageID, dispatch, ftux, dismiss]);
}
